<template>
    <mc-modal
        v-model="visible"
        title="重新选择识别图片"
        :closable="false"
    >
        <div class="image-list">
            <div
                v-for="(imageIten,index) in imageList"
                :key="imageIten.picUrl"
                :class="['image-item', { active: index === selectedImgIndex }]"
                @click="selectedImgIndex = index"
            >
                <mc-image
                    style="width: 120px; height: 120px"
                    :src="imageIten.picUrl"
                />
            </div>
        </div>
        <div slot="footer">
            <mc-button @click="handleClose">
                取消
            </mc-button>

            <mc-button
                type="primary"
                :disabled="selectedImgIndex !== 0 && !selectedImgIndex"
                @click="handleSubmit"
            >
                提交
            </mc-button>
        </div>
    </mc-modal>
</template>

<script>
import { getCurrentInstance, ref } from '@vue/composition-api';

export default {
    setup() {
        const { proxy } = getCurrentInstance();
        const visible = ref(false);

        const selectedImgIndex = ref(null);
        const identifyType = ref('');
        const imageList = ref([]);

        const handleOpen = (list, type) => {
            if (!list.length) {
                proxy.$mc.message.error('暂无可切换的图片');
                return;
            }
            imageList.value = (list || []).filter(Boolean);
            identifyType.value = type;
            visible.value = true;
        };

        const handleClose = () => {
            selectedImgIndex.value = null;
            visible.value = false;
        };

        const handleSubmit = () => {
            proxy.$emit('selectedInfo', imageList.value[selectedImgIndex.value], identifyType.value);
            handleClose();
        };

        return {
            visible,
            handleOpen,
            imageList,
            selectedImgIndex,
            handleClose,
            handleSubmit,
        };
    },
};
</script>

<style lang="scss" scoped>
    .image-list {
        display: flex;
        .image-item {
            margin: 0 5px;
            padding: 5px;
            border: 1px solid #eee;
        }
        .active {
            border: 1px solid #00b85c;
        }
    }

</style>
